export const PLDDT_BANDS = [
  { min: 90, max: 100, color: '#0053D6', label: 'Very high (> 90)' },
  { min: 70, max: 90,  color: '#65CBF3', label: 'Confident (70 – 90)' },
  { min: 50, max: 70,  color: '#FFDB13', label: 'Low (50 – 70)' },
  { min: 0,  max: 50,  color: '#FF7D45', label: 'Very low (< 50)' }
];

export function plddtColor(plddt) {
  if (plddt == null || Number.isNaN(plddt)) return '#808080';
  if (plddt > 90) return '#0053D6';
  if (plddt > 70) return '#65CBF3';
  if (plddt > 50) return '#FFDB13';
  return '#FF7D45';
}

export const plddtColorFunc = (atom) => plddtColor(atom?.b);
